import dayjs from 'dayjs'
import { ActivityDTO } from '~/domain/activity/dto/ActivityDTO'
import { getAvatarUrl } from '~/domain/user/services/UserDTOService'

export interface Props {
  activity: ActivityDTO
}

export const useActivityItem = (props: Props) => {
  const { activity } = props
  const date = activity.publishedAt
    ? dayjs.unix(activity.publishedAt).format('YYYY.MM.DD')
    : undefined

  return {
    activity,
    date,
    avatar: getAvatarUrl(activity.user),
  }
}
